import { configureStore, ConfigureStoreOptions } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { api } from './features/api'
import auth from './features/auth/authSlice'
import advisor from './features/advisor/advisorSlice'
import { chatAdvisorApi } from './features/chatadvisor/chatAdvisorWebsocketSlice'
import { chatAdvisorSliceReducer } from './features/chatadvisor/chatAdvisorSlice.slice'
import { chatAdvisorHttpApi } from './features/chatadvisor/chatAdvisorApi'
import { dashboardApiSlice } from './features/dashboard/dashboardApiSlice'
import { conversationsApiSlice } from './features/conversations/conversationsApiSlice'
import { knowledgeApiSlice } from './features/knowledge/knowledgeApiSlice'
import { fileUploadApi } from './features/knowledge/knowledgeFileUploadApiSlice'
import { settingsApiSlice } from './features/settings/settingsApiSlice'
import { voiceAgentApi } from './features/voiceagent/voiceAgentApiSlice'
import { voiceAgentLogsApi } from './features/voiceagent/voiceAgentLogsApiSlice'
import { speechTokenApiSlice } from './features/speech/speechAuthApiSlice'
import { analyticsApiSlice } from './features/analytics/analyticsApiSlice'
import { agenticAnalystApiSlice } from './features/analytics/agenticAnalystApiSlice'
import { globalCartSliceReducer } from './features/globalCart/globalCartSlice.slice';
import { globalConversationSliceReducer } from './features/conversationhistory/conversationSlice.slice';
import { actionsApiSlice } from './features/actions/actionApiSlice';
import actionsSliceReducer from './features/actions/actionSlice.slice';
import agentsSliceReducer from './features/agents/agentSlice.slice';
import uxgenieSliceReducer from './features/uxgenie/uxgenieSlice.slice';
import workflowSliceReducer from './features/workflow/workflowSlice';
import nodeTypesSliceReducer from './features/workflow/nodeTypesSlice';
import workflowExecutionSliceReducer from './features/workflow/workflowExecutionSlice';
import tenant from './features/settings/tenantSlice';
import mcp from './features/mcp/mcpSlice';
import { mcpApiSlice } from './features/mcp/mcpApiSlice';
import { skillBuilderApiSlice } from './features/guidance/skillBuilderApiSlice';
// Import workflowApiSlice to ensure endpoints are registered
import './features/workflow/workflowApiSlice';
import './features/datamodels/datamodelsApiSlice';

export const createStore = (
  options?: ConfigureStoreOptions['preloadedState'] | undefined,
) =>
  configureStore({
    reducer: {
      [api.reducerPath]: api.reducer,
      auth,
      tenant,
      advisor,
      [chatAdvisorApi.reducerPath]: chatAdvisorApi.reducer,
      chatAdvisorSliceReducer,
      globalCartSliceReducer,
      globalConversationSliceReducer,
      chatAdvisorHttpApi,
      dashboardApiSlice,
      conversationsApiSlice,
      knowledgeApiSlice,
      fileUploadApi,
      settingsApiSlice,
      [voiceAgentApi.reducerPath]: voiceAgentApi.reducer,
      [voiceAgentLogsApi.reducerPath]: voiceAgentLogsApi.reducer,
      speechTokenApiSlice,
      analyticsApiSlice,
      [agenticAnalystApiSlice.reducerPath]: agenticAnalystApiSlice.reducer,
      actionsApiSlice,
      actionsSlice: actionsSliceReducer,
      agentsSlice: agentsSliceReducer,
      uxgenieSlice: uxgenieSliceReducer,
      workflow: workflowSliceReducer,
      nodeTypes: nodeTypesSliceReducer,
      mcp,
      [mcpApiSlice.reducerPath]: mcpApiSlice.reducer,
      [skillBuilderApiSlice.reducerPath]: skillBuilderApiSlice.reducer,
      workflowExecution: workflowExecutionSliceReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(
        api.middleware,
        chatAdvisorApi.middleware,
        fileUploadApi.middleware,
        voiceAgentApi.middleware,
        voiceAgentLogsApi.middleware,
        mcpApiSlice.middleware,
        skillBuilderApiSlice.middleware,
        agenticAnalystApiSlice.middleware
      ),
    ...options,
  })

export type AppDispatch = ReturnType<typeof createStore>['dispatch'];
export const useAppDispatch: () => AppDispatch = useDispatch;
export type RootState = ReturnType<ReturnType<typeof createStore>['getState']>;
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
